import { render, staticRenderFns } from "./bankLinks.vue?vue&type=template&id=7192719a&"
import script from "./bankLinks.vue?vue&type=script&lang=ts&"
export * from "./bankLinks.vue?vue&type=script&lang=ts&"
import style0 from "./bankLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports